export const ru = {
    cancel: 'Отмена',
    description: 'Описание продукта',
    save: 'Сохранить'
};
